import { useId, useState } from "react";

export default function InfoTip({
  label,
  text,
}: {
  label: string;
  text: string;
}) {
  const id = useId();
  const [open, setOpen] = useState(false);
  return (
    <span className={`info-tip${open ? " is-open" : ""}`}>
      <button
        type="button"
        aria-label={`Cos’è ${label}`}
        aria-expanded={open}
        aria-controls={id}
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          setOpen((value) => !value);
        }}
        onBlur={() => setOpen(false)}
      >
        i
      </button>
      <em id={id} role="tooltip" hidden={!open}>
        {text}
      </em>
    </span>
  );
}
